import { SmartphotoImages } from './smartphoto/smartphoto-images.class';
import { SmartphotoEstimation } from './smartphoto/smartphoto-estimation.class';
import { SmartphotoVehicle } from './smartphoto/smartphoto-vehicle.class';
import { SmartphotoDates } from './smartphoto/smartphoto-dates.class';
import { HistoryLogs } from './history-logs.class';
import { SmartphotoReopen } from './smartphoto/smartphoto-reopen.class';
import { SmartphotoReports } from './smartphoto/smartphoto-reports.class';
import { SmartphotoAlerts } from './smartphoto/smartphoto-alerts.class';
import { SmartphotoBodyshopDetails } from './smartphoto/smartphoto-bodyshop-details.class';
import { SmartphotoAdditionals } from './smartphoto/smartphoto-additionals.class';
import { SmartphotoEstimateInfo } from './smartphoto/smartphoto-estimateInfo.class';
import { SmartphotoDeductibleInfo } from './smartphoto/smartphoto-deductible.class';
import { Damage } from './smartphoto/damage/damage.class';
import { SmartphotoFile } from './smartphoto/file/smartphoto-file.class';
import { SmartphotoImage } from './smartphoto/image/smartphoto-image.class';
import { SmartphotoImageAlertAdapter } from '../adapters/smartphoto-image-alert-adapter';
import { SmartphotoInformation } from './smartphoto/smartphoto-information.class';
import { SmartphotoDocument } from './smartphoto/file/smartphoto-document.class';
import { SmartphotoThirdPartyInfo } from './smartphoto/smartphoto-third-party-info.class';
export class Smartphoto {
    lat;
    lng;
    grouping;
    id;
    AIModulesModified;
    attributes;
    assignedAgentId;
    caseRef;
    caseId;
    claimType;
    damagedZones;
    damageSummary; // TODO: Eliminar cuando no lo utilice ningún cliente
    deadlineSelfadjust;
    description;
    email;
    fraudSummary;
    lang;
    masterCompanyId;
    notificationChannel;
    numRef;
    partProviderReports;
    phone;
    prefixInput;
    reopenInstructions;
    report;
    status;
    vehicleType;
    finishedAtTimestamp;
    cancelledBy;
    cancelledAt;
    reviewedByName;
    reviewedAt;
    detectedPartsPerImage;
    thirdPartyInfo;
    type;
    waitingForAI;
    images;
    files;
    documents;
    alerts;
    estimation;
    deductible;
    vehicle;
    dates;
    reports;
    logs;
    reopen;
    basket;
    bodyshopDetails;
    additionals;
    estimateInfo;
    estimationConfig;
    paintSystemConfig;
    paintSystem;
    bodyshopComments;
    plate;
    // createAt no deberia ser ni puede ser un valor opcional; Comprobar y fixear
    createdAt;
    concepts;
    gtPaintSystem;
    constructor(smartphoto, company) {
        const grouping = smartphoto.attributes.useCase === 'Claim' ? 'vehicle_parts' : 'unique';
        this.grouping = smartphoto.reports?.attributes.grouping ?? grouping;
        this.plate = smartphoto.plate;
        this.createdAt = smartphoto.createdAt;
        this.type = smartphoto.attributes.useCase;
        this.vehicle = new SmartphotoVehicle(smartphoto);
        this.dates = new SmartphotoDates(smartphoto.finishedAtTimestamp);
        this.alerts = SmartphotoAlerts.create(smartphoto);
        this.bodyshopDetails = new SmartphotoBodyshopDetails(smartphoto);
        this.concepts = smartphoto.damageSummary
            .map(({ mainDetection, otherDetection }) => new Damage(mainDetection, otherDetection))
            .filter(({ origin, deleted }) => origin === 'additionalCost' && !deleted);
        if (smartphoto.thirdPartyInfo?.estimation) {
            this.thirdPartyInfo = new SmartphotoThirdPartyInfo({
                provider: smartphoto.thirdPartyInfo.estimation.provider,
                error: smartphoto.thirdPartyInfo.estimation.error,
                url: smartphoto.thirdPartyInfo.estimation.data?.url,
                reportUrl: smartphoto.thirdPartyInfo.estimation.data?.report,
                mismatchedParts: smartphoto.thirdPartyInfo.estimation.data?.mismatchedParts
            });
        }
        const motorReports = [];
        const damages = smartphoto.damageSummary.filter(({ mainDetection: { damages: [damage] } }) => {
            const origin = damage?.origin_user ?? damage?.origin;
            return origin === 'claim' && !(damage?.is_deleted_user ?? damage?.is_deleted);
        });
        const damagesDeleted = smartphoto.damageSummary.filter(({ mainDetection: { damages: [{ is_deleted, is_deleted_user, origin }] } }) => Boolean(is_deleted_user ?? is_deleted) && origin !== 'additionalCost');
        if (smartphoto.attributes.useCase === 'Claim') {
            const otherDamages = smartphoto.damageSummary.filter(({ mainDetection: { damages: [damage] } }) => {
                const origin = damage?.origin_user ?? damage?.origin;
                return origin === 'other' && !(damage?.is_deleted_user ?? damage?.is_deleted);
            });
            motorReports.push({
                uuid: crypto.randomUUID(),
                is_main_report: true,
                damages,
                report_type: 'vehicle_parts'
            });
            motorReports.push({
                uuid: crypto.randomUUID(),
                is_main_report: false,
                damages: otherDamages,
                report_type: 'vehicle_parts'
            });
        }
        if (smartphoto.attributes.useCase === 'Underwriting') {
            motorReports.push({
                uuid: crypto.randomUUID(),
                is_main_report: true,
                damages,
                report_type: 'unique'
            });
        }
        motorReports.push({
            uuid: crypto.randomUUID(),
            is_main_report: false,
            damages: damagesDeleted,
            report_type: 'deleted'
        });
        // TODO: Eliminar este codigo cuando la API devuelva de forma correcta un reporte principal
        if (smartphoto.reports?.reports.length === 0) {
            smartphoto.reports.reports.push({
                uuid: crypto.randomUUID(),
                is_main_report: true,
                damages: [],
                // eslint-disable-next-line no-nested-ternary
                report_type: this.grouping === 'sides' ? 'user' : this.grouping === 'impacts' ? 'impact' : this.grouping
            });
        }
        this.reports = smartphoto.reports
            ? new SmartphotoReports(smartphoto.reports, this.thirdPartyInfo?.estimation.mismatchedParts)
            : new SmartphotoReports({
                reports: motorReports,
                smartphoto_id: smartphoto.id,
                createdAt: smartphoto.createdAt ?? 0,
                version: '',
                company_id: smartphoto.master_company_id,
                attributes: {
                    grouping: this.grouping
                }
            }, this.thirdPartyInfo?.estimation.mismatchedParts);
        const mainDamages = [
            ...this.reports.findMainReport().damages,
            ...this.reports.findMainReport().damages.flatMap(({ others }) => others)
        ];
        const secondaryDamages = [
            ...this.reports.findOtherReport().flatMap((report) => report.damages),
            ...this.reports
                .findOtherReport()
                .flatMap((report) => report.damages)
                .flatMap(({ others }) => others)
        ];
        const imageAlertAdapter = new SmartphotoImageAlertAdapter(smartphoto);
        const smartphotoImages = smartphoto.images.map((image) => {
            const damagesWithImages = mainDamages.filter(({ image_info }) => image_info?.image_uuid === image.uuid);
            const secondaryDamagesWithImages = secondaryDamages.filter(({ image_info }) => image_info?.image_uuid === image.uuid);
            const alerts = image.uuid ? imageAlertAdapter.transform(image.uuid) : [];
            const imageData = {
                url: image.name,
                uuid: image.uuid,
                type: image.type,
                caption: image.caption,
                coordinates: image.coordinates,
                takePhotoAt: image.takePhotoAt,
                uploadedBy: image.uploadedBy
            };
            return new SmartphotoImage(imageData, alerts, damagesWithImages, secondaryDamagesWithImages);
        });
        this.documents =
            smartphoto.documents?.map((document) => new SmartphotoDocument(document.type ?? 'Document', document.url ?? '', document.uploadedAt, document.uuid)) ?? [];
        this.images = new SmartphotoImages(smartphotoImages);
        this.files = (smartphoto.files ?? []).map((file) => SmartphotoFile.fromApi(file));
        this.basket = smartphoto.baskets?.at(0);
        this.gtPaintSystem = smartphoto.paint_system;
        if (smartphoto?.baskets?.length) {
            this.basket = smartphoto.baskets.at(0);
        }
        this.logs = new HistoryLogs(smartphoto.logs ?? [], smartphoto.attributes.useCase).logs;
        this.id = smartphoto.id;
        this.AIModulesModified = smartphoto.AIModulesModified;
        this.attributes = smartphoto.attributes;
        this.assignedAgentId = smartphoto.assigned_agent_id;
        this.caseRef = smartphoto.caseRef;
        this.caseId = smartphoto.case_id;
        this.claimType = smartphoto.claimType;
        this.damagedZones = smartphoto.damagedZones;
        this.damageSummary = smartphoto.damageSummary;
        this.deadlineSelfadjust = smartphoto.deadlineSelfadjust;
        this.description = smartphoto.description;
        this.email = smartphoto.email;
        this.fraudSummary = smartphoto.fraudSummary;
        this.lang = smartphoto.lang;
        this.masterCompanyId = smartphoto.master_company_id;
        this.numRef = smartphoto.numRef;
        this.notificationChannel = smartphoto.notificationChannel;
        this.partProviderReports = smartphoto.partProviderReports;
        this.phone = smartphoto.phone;
        this.prefixInput = smartphoto.prefixInput;
        this.reopenInstructions = smartphoto.reopenInstructions;
        this.report = smartphoto.report;
        this.status = smartphoto.status;
        this.vehicleType = smartphoto.vehicleType;
        this.detectedPartsPerImage = smartphoto.detectedPartsPerImage;
        this.waitingForAI = smartphoto.waitingForAI;
        this.lat = smartphoto.lat;
        this.lng = smartphoto.lng;
        this.finishedAtTimestamp = smartphoto.finishedAtTimestamp;
        this.cancelledBy = smartphoto.cancelled_by;
        this.cancelledAt = smartphoto.CancelledAt;
        this.reviewedByName = smartphoto.reviewedByName;
        this.reviewedAt = smartphoto.reviewedAt;
        this.bodyshopComments = smartphoto.bodyshop_comments ?? '';
        this.additionals = new SmartphotoAdditionals(smartphoto);
        this.paintSystemConfig = smartphoto.costEstimationInfo?.paintSystemConfig;
        this.paintSystem = smartphoto.costEstimationInfo?.paintSystem ?? 'twoCoat';
        this.estimationConfig = {
            deductibleMargin: smartphoto.costEstimationInfo?.deductibleMargin ?? company.costEstimationInfo?.deductibleMargin ?? 0,
            taxName: smartphoto.costEstimationInfo?.taxName ?? company.costEstimationInfo?.taxName ?? 'IVA',
            taxPercentage: smartphoto.costEstimationInfo?.taxPercentage ?? company.costEstimationInfo?.taxPercentage ?? 21,
            paintHourPrice: smartphoto.costEstimationInfo?.paintHourPrice ?? company.costEstimationInfo?.paintHourPrice ?? 0,
            labourHourPrice: smartphoto.costEstimationInfo?.labourHourPrice ?? company.costEstimationInfo?.labourHourPrice ?? 0,
            currency: smartphoto.costEstimationInfo?.currency ?? company.costEstimationInfo?.currency ?? '€',
            maxAllowableTax: company.disableCostEstimationUpdate ? null : (company.costEstimationInfo?.taxPercentage ?? 21)
        };
        [...this.getAllDamages(), ...this.getDeletedDamages()].forEach((damage) => damage.estimation.updatePrice({
            labour: this.estimationConfig.labourHourPrice,
            paint: this.estimationConfig.paintHourPrice
        }));
        if (company.damageList) {
            if (this.isDeductible()) {
                this.deductible = new SmartphotoDeductibleInfo([this.reports.findMainReport(), ...this.reports.findOtherReport()], this.estimationConfig.taxPercentage, this.estimationConfig.deductibleMargin, smartphoto.reports?.attributes.roof);
            }
            this.estimation = new SmartphotoEstimation(this.estimationConfig.taxPercentage, [...this.getMainDamages(), ...this.concepts]);
            this.updateConceptsDamages({
                various: this.estimation.total.various,
                consumable: this.estimation.total.consumable,
                pieces: this.estimation.total.pieces
            });
        }
        const information = new SmartphotoInformation(company.selfadjustInfo, smartphoto.template);
        this.reopen = new SmartphotoReopen(this.images, smartphoto.attributes, smartphoto.carpart ?? {}, smartphoto.vehicleType ?? 'car', smartphoto.images, information, smartphoto.documents);
        if (smartphoto.estimateInfo) {
            const { estimateInfo, pendingGTEstimation = false } = smartphoto;
            this.estimateInfo = new SmartphotoEstimateInfo(estimateInfo, pendingGTEstimation, company.estimateProvider?.name === 'GT' ? company.estimateProvider.trigger !== 'manual' : true);
        }
    }
    isDeductible() {
        return this.grouping === 'sides';
    }
    isDamageIncomplete(damage) {
        const { operation, piece = 0, total = 0, provider } = damage.estimation;
        const enabled = Boolean(piece <= 0 || total <= 0 || (this.partProviderReports && provider === undefined));
        return operation === 'replace' && enabled;
    }
    isEstimationIncomplete() {
        return this.getMainDamages().some((damage) => this.isDamageIncomplete(damage));
    }
    get coordinates() {
        if (this.lat && this.lng) {
            return {
                latitude: this.lat,
                longitude: this.lng
            };
        }
        return undefined;
    }
    getMainDamages() {
        return this.deductible?.getDamages() ?? this.reports.findMainReport().damages;
    }
    getAllDamages() {
        return [...this.reports.findMainReport().damages, ...this.reports.findOtherReport().flatMap(({ damages }) => damages)];
    }
    getDeletedDamages() {
        return this.reports.findDeleteReport().damages;
    }
    getAllReports() {
        return [this.reports.findMainReport(), ...this.reports.findOtherReport()];
    }
    addReport(mainReport, type) {
        const reportWithSameType = this.deductible?.getOrderedReports().find((r) => r.type === type);
        if (reportWithSameType) {
            return reportWithSameType;
        }
        const report = this.reports.addReport(mainReport, type);
        this.deductible?.add(report);
        return {
            damages: report.damages,
            uuid: report.uuid
        };
    }
    updateConceptsDamages({ various, consumable, pieces }) {
        this.concepts.forEach((damage) => {
            const { value = {}, operation } = damage.estimation;
            const { type, amount = 0, max = 0, min = 0 } = value;
            if (type === 'fixed') {
                damage.estimation.addCost(amount);
                return;
            }
            if (operation === 'consumable') {
                damage.estimation.addCost(SmartphotoEstimation.getPercentage(pieces, amount, max, min));
                return;
            }
            if (operation === 'excess') {
                damage.estimation.addCost(SmartphotoEstimation.getPercentage(various, amount, max, min));
                return;
            }
            if (operation === 'discount') {
                damage.estimation.addCost(SmartphotoEstimation.getPercentage(various + consumable, amount, max, min));
                return;
            }
            damage.estimation.addCost(amount);
        });
    }
    getTotalDamagesBySeverity() {
        const defaultSeverityStructure = {
            '-': 0,
            superficial: 0,
            low: 0,
            mid: 0,
            high: 0
        };
        return this.getMainDamages()
            .filter((damage) => damage.severity !== '-')
            .reduce((acc, i) => {
            acc[i.severity] += 1;
            return acc;
        }, defaultSeverityStructure);
    }
}
